import { Observable, ErrorSource, generateUUID, computeRawError, combine } from '@datadog/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
import { trackConsoleError } from './trackConsoleError';
import { trackReportError } from './trackReportError';
export function startErrorCollection(lifeCycle, configuration, bufferedDataObservable) {
  var errorObservable = new Observable();
  bufferedDataObservable.subscribe(function (bufferedData) {
    if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */) {
      errorObservable.notify(bufferedData.error);
    }
  });
  trackConsoleError(errorObservable);
  trackReportError(configuration, errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle);
}
export function doStartErrorCollection(lifeCycle) {
  lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_ref) {
    var error = _ref.error;
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processError(error));
  });
  return {
    addError: function addError(_ref2) {
      var error = _ref2.error,
        handlingStack = _ref2.handlingStack,
        componentStack = _ref2.componentStack,
        startClocks = _ref2.startClocks,
        context = _ref2.context;
      var rawError = computeRawError({
        originalError: error,
        handlingStack: handlingStack,
        componentStack: componentStack,
        startClocks: startClocks,
        nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
        source: ErrorSource.CUSTOM,
        handling: "handled" /* ErrorHandling.HANDLED */
      });
      rawError.context = combine(rawError.context, context);
      lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
        error: rawError
      });
    }
  };
}
function processError(error) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: generateUUID(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      component_stack: error.componentStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser',
      fingerprint: error.fingerprint,
      csp: error.csp
    },
    type: RumEventType.ERROR,
    context: error.context
  };
  var domainContext = {
    error: error.originalError,
    handlingStack: error.handlingStack
  };
  return {
    rawRumEvent: rawRumEvent,
    startClocks: error.startClocks,
    domainContext: domainContext
  };
}